import { Component, ViewChild, OnInit } from '@angular/core';
import {
  ApexAxisChartSeries,
  ApexChart,
  ApexDataLabels,
  ApexGrid,
  ApexOptions,
  ApexStroke,
  ApexTitleSubtitle,
  ApexXAxis,
  ChartComponent,
} from 'ng-apexcharts';

import { ApiModels } from '@reenstudio/app/core/models/charts/peaks-model';
import { EventService } from '@reenstudio/app/core/services/event-service';
import { Subscription, of, switchMap } from 'rxjs';
import { PeaksChartService } from '@reenstudio/app/core/services/charts/peaks-service';
import { NGXLogger } from 'ngx-logger';
import { peaksChartObj } from '@reenstudio/app/core/models/charts/peaks-model';
import { StorageService } from '@reenstudio/app/core/services/storage.service';
import { UserRole } from '@reenstudio/app/core/enum/user-role';
import { PeakChartApiService } from '@reenstudio/app/core/services/charts-api/peak-api-service';
import { SiteService } from '@reenstudio/app/core/services/site-service';
import { SiteApiService } from '@reenstudio/app/core/services/api/site.services';

@Component({
  selector: 'app-peaks',
  templateUrl: './peaks.component.html',
  styleUrls: ['./peaks.component.scss'],
})
export class PeaksComponent implements OnInit {
  @ViewChild('peaksChart') peaksChart!: ChartComponent;
  public chartOptions: Partial<ApexOptions> | any;
  subscription: Subscription;

  loading: boolean = false;
  selectedSite: number = 1;
  selectedSiteName: string;

  peaksChartObj: peaksChartObj = {
    consumato: [],
    prodotto: [],
    consumatoPicco: [],
    produzionePicco: [],
    ore: [],
    formattedHours: [],
    series: [],
    start: new Date(),
    end: new Date(),
  };

  wrongFilters: boolean = false;

  constructor(
    private apiService: PeakChartApiService,
    private chartService: PeaksChartService,
    private storageService: StorageService,
    private siteService: SiteService,
    private siteApiService: SiteApiService,
    private logger: NGXLogger
  ) {
    this.chartService.setPeaksChart(this.peaksChartObj);
  }

  ngOnInit(): void {
    EventService.pageFilters.subscribe((data) => {
      this.peaksChartObj.start = new Date(
        this.peaksChartObj.end.getTime() - 24 * 60 * 60 * 1000
      );
      if (this.storageService.getLevel() === UserRole.SITE) {
        if (
          (data.periodType === 'days' || data.periodType === 'custom') &&
          data.periodValue === '1'
        ) {
          this.siteService.setSelectedSite().subscribe((selectedSite: any) => {
            this.selectedSite = selectedSite.id;
            this.selectedSiteName = selectedSite.description;
          });
        } else {
          this.siteService.setSelectedSite().subscribe((selectedSite: any) => {
            this.selectedSite = selectedSite.id;
            this.selectedSiteName = selectedSite.description;
          });
        }
      } else {
        if (
          (data.periodType === 'days' || data.periodType === 'custom') &&
          data.periodValue === '1'
        ) {
          this.siteService.setSelectedSite().subscribe((selectedSite: any) => {
            this.selectedSite = selectedSite.id;
            this.selectedSiteName = selectedSite.description;
          });
        } else {
          this.selectedSite = 1;
          this.selectedSiteName = 'Prosumer 1';
        }
      }

      this.getData(this.selectedSite);
    });

    this.siteService.setSelectedSite().subscribe((selectedSite: any) => {
      this.selectedSite = selectedSite.id;
      this.selectedSiteName = selectedSite.description;
    });

    this.getData(this.selectedSite);

    EventService.changeCer.subscribe(() => {
      const cer = this.storageService.getCer();
      if (cer) {
        this.getData(cer);
      }
    });

    EventService.changeSite.subscribe(() => {
      this.siteService.setSelectedSite().subscribe((selectedSite: any) => {
        this.selectedSite = selectedSite.id;
        this.selectedSiteName = selectedSite.description;
        this.getData(selectedSite.id);
      });
    });
  }

  getData(site: number) {
    this.loading = true;

    this.peaksChartObj.start = new Date(
      this.peaksChartObj.end.getTime() - 24 * 60 * 60 * 1000
    );
    let cer = this.storageService.getCer();

    if (
      cer &&
      this.selectedSite &&
      this.peaksChartObj.start &&
      this.peaksChartObj.end
    ) {
      this.subscription = this.apiService
        .getPeak(
          cer,
          this.selectedSite,
          this.peaksChartObj.start,
          this.peaksChartObj.end
        )
        .pipe(
          switchMap((apiData: ApiModels) => {
            this.logger.debug('Peaks API data', apiData);

            this.peaksChartObj = {
              consumato: [],
              prodotto: [],
              consumatoPicco: [],
              produzionePicco: [],
              ore: [],
              formattedHours: [],
              series: [],
              start: new Date(),
              end: new Date(),
            };

            this.chartOptions = this.chartService.setPeaksChart(
              this.peaksChartObj
            );

            // Esegui i calcoli necessari
            const res = this.chartService.getPeaksData(
              apiData,
              this.peaksChartObj
            );

            this.peaksChartObj = res;

            this.logger.debug('Peaks managed data', res);

            // Ritorna un Observable di completamento
            return of(null);
          })
        )
        .subscribe(() => {
          this.loading = false;
          this.chartOptions = this.chartService.setPeaksChart(
            this.peaksChartObj
          );
          this.logger.debug('Peaks chartOptions data', this.chartOptions);
        });
    } else {
      this.wrongFilters = true;
    }
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }
}

export type ChartOptions = {
  series: ApexAxisChartSeries;
  chart: ApexChart;
  xaxis: ApexXAxis;
  dataLabels: ApexDataLabels;
  grid: ApexGrid;
  stroke: ApexStroke;
  title: ApexTitleSubtitle;
};
